import React from 'react';


import Filterable from '@components/Filterable/Filterable';
import ButtonsList from './ButtonsList';
import { buttonsSet, FILTERS } from './constants';

/*
  Presentational component for Buttons
*/

const Buttons = () => (
  <Filterable
    customClasses={'main-content'}
    filters={FILTERS}
    data={buttonsSet}
    withoutSearch
  >
    <ButtonsList/>
  </Filterable>
);

Buttons.displayName = 'ButtonsPage';

export default Buttons;



// WEBPACK FOOTER //
// ./src/containers/elements/Buttons/Buttons.js